<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <input type="hidden" name="menuType" id="menuType" value="public" />
    
    <div tabindex="101" *ngIf="appError" class="ontario-row">
      <div class="ontario-columns">
        <div class="ontario-alert ontario-alert--error " aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
          #pageMsg>
          <div class="ontario-alert__header">
            <div class="ontario-alert__header-icon">
              <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
                viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-alert-error"></use>
              </svg>
            </div>
            <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
          </div>
          <div class="ontario-alert__body">
            <p [innerHTML]="getErrorMessage() | translate">
          </div>
        </div>
      </div>
    </div>

    <div class="ontario-row">
      <div class="ontario-columns">
        <h2 id="pageTitle">{{'bss.passwordForgot.title'|translate}}</h2>
        <hr>
        <p>{{'bss.passwordForgot.subTitle'|translate}}</p>

        <form [formGroup]="passwordForgotForm">
          <label class="ontario-label" for="email">
            {{'bss.passwordForgot.emailAddress'|translate}}
          </label>
          <input tabindex="102" aria-describedby="emailError" class="ontario-input ontario-input--20-char-width"
            formControlName="email" type="email" id="email" name="email"
            title="{{'bss.passwordForgot.input.title' | translate}}" appLowercase>

          <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
            *ngIf="(submitted || passwordForgotForm.get('email').touched && !canceled || passwordForgotForm.get('email').dirty) 
            && ( passwordForgotForm.get('email').errors?.['required'] ||passwordForgotForm.get('email')?.hasError('email') || passwordForgotForm.get('email')?.hasError('invalidEmail') )">
            {{ 'bss.passwordForgot.error.emailAddress.required' | translate }}
          </div>

          <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
            *ngIf="(submitted || passwordForgotForm.get('email').touched && !canceled) && (passwordForgotForm.controls['email'].errors?.['email'])">
            {{ 'bss.passwordForgot.error.emailAddress.invalid' | translate }}
          </div>

          <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
            *ngIf=" passwordForgotForm.controls['email'].errors?.['restricted']">
            {{ 'bss.login.err.email.restricted' | translate }}
          </div>

          <button tabindex="103" class="ontario-button ontario-button--primary" (keyup.enter)="onSubmit()"
            (click)="onSubmit()" title="{{ 'bss.passwordForgot.submit.title' | translate }}"
            aria-describedby="pageLevelMessageId">
            {{ 'bss.passwordForgot.submit' | translate }}
          </button>

          <button tabindex="104" class="ontario-button ontario-button--secondary"
            title="{{ 'bss.passwordForgot.cancel.title' | translate }}" (click)="onCancel()">
            {{ 'bss.passwordForgot.cancel' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
<dialog class="ontario-progress" #progressDialog>

  <app-progress></app-progress>

</dialog>